'use strict';

const GOOGLE_CLOUD_STORAGE_OPTION = Object.freeze({
  value: 'gcp:',
  text: 'Google Cloud Storage',
});

function activeAwsEnvironments(environments) {
  return (environments || []).filter(
    (environment) =>
      environment?.id &&
      String(environment.cloudProvider || '').toLowerCase() === 'aws' &&
      String(environment.status || '').toLowerCase() === 'active' &&
      !environment.removedAt
  );
}

/**
 * Show the provider product name by default. Environment names are operational
 * metadata, so expose them only when multiple AWS targets must be distinguished.
 */
function buildStorageTargetOptions(environments) {
  const awsEnvironments = activeAwsEnvironments(environments);
  const labelCounts = new Map();

  if (awsEnvironments.length > 1) {
    for (const environment of awsEnvironments) {
      const name = String(environment.name || '').trim();
      const label = name ? `Amazon S3 — ${name}` : 'Amazon S3';
      labelCounts.set(label, (labelCounts.get(label) || 0) + 1);
    }
  }

  const awsOptions = awsEnvironments.map((environment) => {
    let text = 'Amazon S3';
    if (awsEnvironments.length > 1) {
      const name = String(environment.name || '').trim();
      const baseLabel = name ? `Amazon S3 — ${name}` : 'Amazon S3';
      text =
        labelCounts.get(baseLabel) > 1 || !name
          ? `${baseLabel} (#${environment.id})`
          : baseLabel;
    }
    return { value: `aws:${environment.id}`, text };
  });

  return [{ ...GOOGLE_CLOUD_STORAGE_OPTION }, ...awsOptions];
}

module.exports = { buildStorageTargetOptions };
